// extracted by mini-css-extract-plugin
export default {"Container":"staff_Container__oMbb1","Staff":"staff_Staff__w3PAH"};